module.exports = __webpack_public_path__ + "translations/en/verify.json";


//////////////////
// WEBPACK FOOTER
// ./translations/en/verify.json
// module id = ./translations/en/verify.json
// module chunks = 1